import { GrabCentsLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/GrabCentsLine';
import { GrabCentsTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/GrabCentsTacticPanel';
import { AddGrabCentsTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/grabCents/AddGrabCentsTacticPanel';
import { GrabCentsWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/GrabCentsModule/wrapper/GrabCentsWrapper';
import GrabCentsDocs from '../../../../components/forms/tradeplans/documentation/GrabCentsDocumentation';
import GrabCentsModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/GrabCentsModule';
import { GrabCentsData } from './grabCentsData';
import { validateGrabCents } from './validateGrabCents';

export const GrabCents = {
  //data class
  dataStore: GrabCentsData,

  //string constants
  name: 'GRAB_CENTS',
  tacticLabel: 'Grab Cents',
  addTacticLabel: 'Add Grab Cents',
  category: 'Exit',

  // components
  tradePlanFormModule: GrabCentsModule,
  tacticPanel: GrabCentsTacticPanel,
  addTacticPanel: AddGrabCentsTacticPanel,
  wrapper: GrabCentsWrapper,
  chartSoftOrderComponent: GrabCentsLine,
  documentation: GrabCentsDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateGrabCents,
};
